import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";

import { appointmentQKeys } from "@hooks/queries/appointment/queryKeys";
import { consultationQKeys } from "@hooks/queries/consultation/queryKeys";
import { scheduleQKeys } from "@hooks/queries/schedule/queryKeys";


interface MutationProps {
  appointmentId: string;
}

export const useAcceptAppointment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ appointmentId }: MutationProps) => {
      return api.patch(`appointments/${appointmentId}/accept`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: appointmentQKeys.all() });
      queryClient.invalidateQueries({ queryKey: consultationQKeys.all() });
      queryClient.invalidateQueries({ queryKey: scheduleQKeys.all() });
    },

    onError: (res: any) => {
      console.error("[From Accept Appointment]", res);
      queryClient.invalidateQueries({ queryKey: appointmentQKeys.all() });
      queryClient.invalidateQueries({ queryKey: scheduleQKeys.all() });
    },
  });
};
